<template>
    <v-container fluid>

        <v-row justify="start" class="mt-6 ml-1">
            <v-col>
                <v-btn color="success" @click="back()">返回</v-btn>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-data-table :headers="headers" :items="table_data" :search="search_text" class="elevation-1">
                    <template v-slot:item.id="{ item }">
                        {{table_data.findIndex(items => { return items.id == item.id})+1}}
                    </template>
                </v-data-table>
            </v-col>
        </v-row>

    </v-container>
</template>
<script>
import bus from '../nav/bus'

var host_url = process.env.VUE_APP_HOST_URL 
export default {
    data(){
        return {
            type_: "",
            search_text: "",
            page: 0,
            vendor_dialog: false,
            vendor_dialog_title: "",
            headers: [
                {text: '編號', align: 'center', value: 'id', width: 60, sortable: false},
                {text: '面額', align: 'center', value: 'denominations', width: 120},
                {text: '剩餘張數', align: 'center', value: 'remaining_quantity', width: 120, sortable: false},
                {text: '剩餘總額', align: 'center', value: 'remaining_sum', width: 80, sortable: false},
            ],
            table_data: [],
           
            vendor_id: parseInt(localStorage.getItem('vendor_id')),
        }
    },
    created(){
        this.init()
    },
    methods: {
        back(){
            this.$router.push('/line_point_setting')
        },
        init(){
            axios.get(host_url+'get_line_point_data/')
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.table_data = tmp.data
                }
                else{
                    console.log('Get line point error')
                }
            })
            .catch((error) => {
                console.log(error)
            })
        }
    }
}
</script>